"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserPickupVouchers = undefined;

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reduxConnect = require("redux-connect");

var _UserPickupVouchersPanel = require("../../components/uservouchers/UserPickupVouchersPanel");

var _UserPickupVouchersPanel2 = _interopRequireDefault(_UserPickupVouchersPanel);

var _SinglePickupVoucherPanel = require("../../components/uservouchers/SinglePickupVoucherPanel");

var _SinglePickupVoucherPanel2 = _interopRequireDefault(_SinglePickupVoucherPanel);

var _VoucherUtil = require("../../utils/VoucherUtil");

var _userPickupVouchers = require("../../redux/modules/userPickupVouchers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserPickupVouchers = exports.UserPickupVouchers = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(UserPickupVouchers, _Component);

  function UserPickupVouchers() {
    (0, _classCallCheck3.default)(this, UserPickupVouchers);
    return (0, _possibleConstructorReturn3.default)(this, (UserPickupVouchers.__proto__ || (0, _getPrototypeOf2.default)(UserPickupVouchers)).apply(this, arguments));
  }

  (0, _createClass3.default)(UserPickupVouchers, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkVoucher(this.props);
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps) {
      this.checkVoucher(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Ostetut noutolipukkeet" }),
        this.defineContent()
      );
    }
  }, {
    key: "updateVoucherPrintInfo",
    value: function updateVoucherPrintInfo(data) {
      var _props = this.props,
          user = _props.user,
          updateVoucherPrintInfo = _props.updateVoucherPrintInfo;


      (0, _userPickupVouchers.updatePickupVoucherPrintInfo)(user.id, data);
    }
  }, {
    key: "defineContent",
    value: function defineContent() {
      var _props2 = this.props,
          params = _props2.params,
          vouchers = _props2.vouchers;

      var voucher = (0, _VoucherUtil.getCurrentVoucher)(vouchers, params);
      if (voucher) {
        return _react2.default.createElement(_SinglePickupVoucherPanel2.default, (0, _extends3.default)({ voucher: voucher }, this.props));
      }

      if (params && params.voucherId && !voucher) {
        return null;
      }

      return _react2.default.createElement(_UserPickupVouchersPanel2.default, this.props);
    }
  }, {
    key: "checkVoucher",
    value: function checkVoucher(props) {
      var params = props.params,
          vouchers = props.vouchers;

      if (params && params.voucherId) {
        var voucher = (0, _VoucherUtil.getCurrentVoucher)(vouchers, params);
        if (!voucher) {
          this.props.pushRoute("/");
        }
      }
    }
  }]);
  return UserPickupVouchers;
}(_react.Component), _class.propTypes = {
  vouchers: _react.PropTypes.array,
  pushRoute: _react.PropTypes.func.isRequired,
  params: _react.PropTypes.object,
  pathname: _react.PropTypes.string.isRequired
}, _temp);
exports.default = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];

    promises.push(dispatch((0, _userPickupVouchers.loadPickupVouchers)()));

    return _promise2.default.all(promises);
  }
}])((0, _reactRedux.connect)(function (state) {
  return {
    vouchers: state.userPickupVouchers.vouchers,
    vouchersInfoUpdated: state.userPickupVouchers.vouchersInfoUpdated,
    pathname: state.routing.locationBeforeTransitions.pathname
  };
}, {
  pushRoute: _reactRouterRedux.push,
  updateVoucherPrintInfo: _userPickupVouchers.updatePickupVoucherPrintInfo
})(UserPickupVouchers));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/UserVouchers/UserPickupVouchers.js
 ** module id = 1247
 ** module chunks = 0
 **/